import r from './image-bitmap-data-url-worker.js';

function t(){const t=new Blob([r]);return URL.createObjectURL(t)}

export { t as getImageBitmapDataUrlWorkerURL };
